var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductosEscolares(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5177 29.6382L17.5278 26.1481L5.81722 12.4784L1.33232 7.24326C3.5132 4.47624 5.01178 3.19621 8.16718 1.38795L12.6521 6.62313L24.3626 20.2928L27.3526 23.7829L20.5177 29.6382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5278 26.1481L20.5177 29.6382L27.3526 23.7829L24.3626 20.2928M17.5278 26.1481C18.8852 25.6576 22.1526 23.7998 24.3626 20.2928M17.5278 26.1481L5.81722 12.4784M24.3626 20.2928L12.6521 6.62313M5.81722 12.4784C7.98956 9.99251 9.53835 8.73138 12.6521 6.62313M5.81722 12.4784L1.33232 7.24326C3.5132 4.47624 5.01178 3.19621 8.16718 1.38795L12.6521 6.62313",
    stroke: "#359C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductosEscolares);
export default __webpack_public_path__ + "static/media/productos-escolares.212035245d3932cdeb89e0b98dd3cf5a.svg";
export { ForwardRef as ReactComponent };